import { render } from "./WisdomExam.vue?vue&type=template&id=4162e957&scoped=true"
import script from "./WisdomExam.vue?vue&type=script&lang=js"
export * from "./WisdomExam.vue?vue&type=script&lang=js"

import "./WisdomExam.vue?vue&type=style&index=0&id=4162e957&lang=css"
import "./WisdomExam.vue?vue&type=style&index=1&id=4162e957&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4162e957"]])

export default __exports__